import { CctvStatusEnum } from 'api/enums';
import { FC, useMemo } from 'react';

interface CctvStatusBadgeProps {
    status: CctvStatusEnum;
}
const CctvStatusBadge: FC<CctvStatusBadgeProps> = (props) => {
    const { status } = props;

    const options = useMemo(() => {
        let bgClass = '';
        let textClass = '';
        let label = '';

        switch (status) {
            case CctvStatusEnum.ONLINE:
                bgClass = 'bg-success-500';
                textClass = 'text-success-500';
                label = 'Online';
                break;
            case CctvStatusEnum.OFFLINE:
                bgClass = 'bg-danger-500';
                textClass = 'text-danger-500';
                label = 'Offline';
                break;
            case CctvStatusEnum.LOADING:
                bgClass = 'bg-warning-500';
                textClass = 'text-warning-500';
                label = 'Connecting';
                break;
        }

        return {
            bgClass,
            textClass,
            label,
        };
    }, [status]);

    return (
        <div className="inline-flex items-center gap-[6px]">
            <span className={['w-[6px] h-[6px] rounded-full', options.bgClass].join(' ')}></span>
            <span className={['text-xs font-medium', options.textClass].join(' ')}>{options.label || '-'}</span>
        </div>
    );
};

export default CctvStatusBadge;
